import _ from 'lodash';

export default class WeatherModel {
  icon = '';

  constructor(weatherData = {
    icon: '',
  }) {
    this.icon = weatherData.icon;
  }

  setIcon(icon) {
    this.icon = icon;
    return this;
  }

  containsIcon() {
    return this.icon !== '';
  }

  mapFrom(apiData) {
    this.icon = _.get(apiData, 'weather[0].icon', this.icon);
    return this;
  }
}
